<template>
    <span>
        <slot v-if="isVisible" />
    </span>
</template>

<script>
import inViewport from 'vue-in-viewport-mixin';

export default {
    name: 'UiIsVisible',
    data() {
        return {
            isVisible: false,
        };
    },
    mixins: [inViewport],
    watch: {
        'inViewport.now': {
            handler(value) {
                if (value) {
                    this.isVisible = true;
                }
            },
        },
    },
};
</script>
